import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

const customReportsState = (state: RootState) => state.customReportDataState;

export const currentReportSelector = createSelector(
  [customReportsState],
  // eslint-disable-next-line consistent-return
  (state) => {
    const currentReport = state.reports.find(
      (report) => report.reportConfigurationId === state.selectedReportID
    );

    if (currentReport) {
      return currentReport;
    }
  }
);

export const prtflRefreshOnlyReportSelector = createSelector(
  [customReportsState],
  // eslint-disable-next-line consistent-return
  (state) => {
    const prtflRefreshOnlyReport = state.reports.find(
      (report) => report.name === 'Portfolio Refresh Only'
    );

    if (prtflRefreshOnlyReport) {
      return prtflRefreshOnlyReport;
    }
  }
);
